import { TValidacaoCodigo } from './types'

export const RESPONSE_VALIDA_CODIGO = {
  SUCCESS: { info: 'Código válido', status: 'SUCCESS', icon: 'success' },
  ERROR: { info: 'Insira um código válido', status: 'ERROR', icon: 'clear' },
  FAIL: { info: 'Não foi possível validar seu código ', status: 'FAIL', icon: 'clear' },
  DEFAULT: { status: 'UNDEFINED' },
} as TValidacaoCodigo
